import { useCallback, useLayoutEffect } from 'react';

import { EMPTY_FUNCTION } from '../constants';

import { EventType, UseCaptureClickProps } from './types';

export const useCaptureClick = ({
  refs,
  onClickInside = EMPTY_FUNCTION,
  onClickOutside = EMPTY_FUNCTION,
}: UseCaptureClickProps) => {
  const handleClick = useCallback(
    (event: EventType) => {
      const target = event.target as Node;
      const is_inside = refs.some((ref) => ref.current && ref.current.contains(target));

      if (is_inside) {
        onClickInside(event);
      } else {
        onClickOutside(event);
      }
    },
    [refs, onClickInside, onClickOutside]
  );

  useLayoutEffect(() => {
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [handleClick]);
};
